import { FUND_TYPES, BENEFIT_FUND_TYPES, CONTACT_FUND_TYPES, STATES } from '../constants/constants';

/**
 * Get the display label for a fund type.
 * @param {string} fundType - The fund type code (PPC, WINTERHELP, etc.)
 * @returns {string} Human-readable fund type label
 */
export const getFundTypeLabel = (fundType) => {
  if (fundType === FUND_TYPES.PPC) return 'OLIBA';
  if (fundType === FUND_TYPES.WINTERHELP) return 'Winter Help';
  return fundType || '';
};


export const getAvailableBenefitFundTypes = (state, agencyName) => {
  const isWA = state === STATES.WA;
  const isOR = state === STATES.OR;
  const internal = 'MDU';

  return BENEFIT_FUND_TYPES.filter(ft => {
    // CARES: WA only
    if (ft.value === FUND_TYPES.CARES && !isWA) return false;

    // PPC (OLIBA): OR only
    if (ft.value === FUND_TYPES.PPC && !isOR) return false;

    // Winter Help: WA & OR Accounts only, and Internal (MDU) agencies only
    if (ft.value === FUND_TYPES.WINTERHELP && !((isWA || isOR) && agencyName === internal)) {
      return false;
    }

    return true;
  });
};

  // Filter fund types based on customer state
  // Types with no `states` property are available in all states
export const availableContactFundTypes = state => {
  return CONTACT_FUND_TYPES.filter((type) => !type.states || type.states.includes(state)
)};